import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { ToastService } from '@mode/shared/util-toast';

export const DowngradedSharedUtilToastModule = angular
  .module('downgraded-shared-util-toast', [])
  .service('ToastService', downgradeInjectable(ToastService)).name;
